import React from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import PropTypes from 'prop-types';
import { ListTile } from '@thd-olt-component-react/list-tile';
import classNames from 'classnames';

const ListCarousel = ({ lists }) => {

  return (
    <div id="ListCarousel" data-testid="ListCarousel">
      <Carousel
        type="peek"
        layout="full-bleed"
        containerId="ListCarousel"
        slidesPerView="auto"
        slidesPerGroup={1}
        spaceBetween={0}
        breakpoints={{
          sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
          md: { slidesPerGroup: 1, slidesPerView: 'auto' },
          lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
          xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
          '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' },
        }}
        disableMargin
      >
        {lists?.map((list, index) => (
          <div className={
            classNames('sui-w-full sui-w-72 lg:sui-w-80 2xl:sui-w-96', {
              'sui-mr-4': index !== lists.length - 1,
            })
          }
          >
            <ListTile
              iconSize="small"
              key={index + list.id}
              listId={list.id}
              onDelete={() => {}}
              data={list}
              useLatestDesign
              numberOfThumbnails={2}
              position={index}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

ListCarousel.propTypes = {
  lists: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
};

export default ListCarousel;
